import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { MapService } from 'src/app/Service/map.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import axios from 'src/app/Service/axios';
import * as XLSX from 'xlsx';
declare let $: any;

@Component({

  selector: 'app-gps-installer',

  templateUrl: './gps-installer.component.html',

  styleUrls: ['./gps-installer.component.css']

})

export class GpsInstallerComponent implements OnInit {

  lst_Installer: any[] = [];

  lst_Search: any[] = [];

  bEditMode: boolean = false;

  mdl_Search: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    strFamily: new FormControl(''),

    strMobile: new FormControl(''),

    tiAvtive: new FormControl(-1),

  })

  mdl_Request: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    iInstaller: new FormControl(''),

    strFullName: new FormControl('', Validators.required),

    strMobile1: new FormControl('', Validators.required),

    strMobile2: new FormControl(''),

    strTel: new FormControl(''),

    strAddress: new FormControl(''),

    index: new FormControl(''),

    bActive: new FormControl(false),

  })

  constructor(

    private _tooltip: NotificationService,

    private FormBuilder: FormBuilder,

    private router: Router,

    private gurdService: GurdServiceService,

    private _otherService: OtherService,

    private _mapService: MapService

  ) { }

  ngOnInit(): void {

    this.search_Installer()

  }

  async search_Installer() {

    this._otherService.Showspinner();

    let res = JSON.parse((await axios.post(`Installer_List`, this._otherService.stringNumberToNumber(this.mdl_Search.value))).data.toString());

    this._otherService.nonespinner();

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lst_Installer = res;

    this.lst_Search = res;

  }

  async add_Installer(item?, index?) {

    if (item) {

      this.bEditMode = true;

      Object.keys(item).forEach(key => {

        this.mdl_Request.get(key)?.setValue(item[key])

      })

      this.mdl_Request.patchValue({

        index: index

      })

      $("#Installer_modal").modal("show");

    }

    else {

      this.bEditMode = false;

      this.mdl_Request.patchValue({

        strFullName: '',

        strMobile1: '',

        strMobile2: '',

        strTel: '',

        strAddress: '',

        bActive: false,

      })

      $("#Installer_modal").modal("show");

    }

  }

  async submit_Request() {

    if (this.mdl_Request.invalid) return this._tooltip.showError('فرم را با دقت تکمیل کنید');

    this._otherService.Showspinner();

    if (this.bEditMode) {

      $.confirm({

        title: `آیا از ویرایش اطلاعات اطمینان دارید ؟`,

        content: '',

        type: 'blue',

        buttons: {

          ok: {

            text: "تایید",

            btnClass: 'btn-primary',

            keys: ['enter'],

            action: async () => {

              let res = JSON.parse((await axios.post(`Installer_Edit`, this._otherService.stringNumberToNumber(this.mdl_Request.value))).data.toString());

              this._otherService.nonespinner();

              if (res.ISSessionExpired == true) {

                this._tooltip.showError('لطفا وارد سیستم شوید');

                this._otherService.removeLocalStorage();

                this.router.navigate(['login'], { queryParams: { error: 'xq11s10' } });

                return;

              }

              if (res.iResult == 0) return this._tooltip.showError(res.strError);

              this.lst_Installer[this.mdl_Request.get('index')?.value] = res[0];

              this._tooltip.showSuccess('با موفقیت ویرایش شد');

              $("#Installer_modal").modal("hide");

            }

          },

          cancel: {

            text: "لغو",

          }

        }

      });


    }

    else {

      let res = JSON.parse((await axios.post(`Installer_Save`, this._otherService.stringNumberToNumber(this.mdl_Request.value))).data.toString());

      this._otherService.nonespinner();

      if (res.ISSessionExpired == true) {

        this._tooltip.showError('لطفا وارد سیستم شوید');

        this._otherService.removeLocalStorage();

        this.router.navigate(['login'], { queryParams: { error: 'xq11s10' } });

        return;

      }

      if (res.iResult == 0) return this._tooltip.showError(res.strError);

      this.lst_Installer.push(res[0]);

      this._tooltip.showSuccess('با موفقیت ذخیره شد');

      $("#Installer_modal").modal("hide");

    }


  }

  filter_list(val: any) {

    this.lst_Installer = this.lst_Search.filter((el: any) => {

      return el?.strFullName?.includes(val.value) || el.strMobile1.includes(val.value)

    });

    if (val.value.trim() == '') {

      this.lst_Installer = this.lst_Search;

    }

  }

  exportExcel(id: any): void {
    /* pass here the table id */
    let element = document.getElementById(`${id}`);
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, 'جستجوی مسافران.xlsx');
  }

  highlightText(text: string, searchTerm: string) {

    if (!searchTerm) {

      return text;

    }

    const regex = new RegExp(searchTerm, 'gi');

    return text?.replace(regex, (match: string) => {

      return `<mark>${match}</mark>`;

    });

  }

  remove_Installer(item: any, index: number) {

    $.confirm({

      title: `آیا از حذف اطمینان دارید ؟`,

      content: '',

      type: 'red',

      buttons: {

        ok: {

          text: "حذف",

          btnClass: 'btn-danger',

          keys: ['enter'],

          action: async () => {

            var model = {

              strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,

              iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

              iInstaller: item.iInstaller,

            };

            const resp = await axios.post(`Installer_Delete`, model);

            let resParse = JSON.parse(resp.data);

            if (resParse.iResult == 0) return this._tooltip.showError(resParse.strError);

            if (resParse.ISSessionExpired == true) {

              this._tooltip.showError('لطفا وارد سیستم شوید');

              this._otherService.removeLocalStorage();

              this.router.navigate(['login']);

              return;
            }

            else {

              this._tooltip.showSuccess("با موفقیت حذف شد");

              this.lst_Installer.splice(index, 1);

            }

          }

        },

        cancel: {

          text: "لغو",

        }
      }

    });

  }


}
